import React from "react";
import { Box, CircularProgress } from "@mui/material";

const UsersLayoutLoading = () => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: 400,
    }}
  >
    <CircularProgress />
  </Box>
);

export default UsersLayoutLoading;
